import { render, staticRenderFns } from "./EventSearch.vue?vue&type=template&id=4b5f43ac&scoped=true"
import script from "./EventSearch.vue?vue&type=script&lang=js"
export * from "./EventSearch.vue?vue&type=script&lang=js"
import style0 from "./EventSearch.vue?vue&type=style&index=0&id=4b5f43ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5f43ac",
  null
  
)

export default component.exports